module.exports = __webpack_public_path__ + "static/media/foodco.dae78187.png";